module.exports = "/_next/static/images/Street Food-amico-a7345a24ccf75a8eb1bd8f6da0802c07.svg";